import * as Yup from 'yup';

// Helper function to convert multilingual data to old format for backward compatibility
export const convertToBackendFormat = (multiLangData) => {
  // Use English as primary language (fallback)
  const result = {
    graded: multiLangData.graded?.en || multiLangData.graded || '',
    gradedDescription:
      multiLangData.gradedDescription?.en ||
      multiLangData.gradedDescription ||
      '',
    translations: {
      graded: multiLangData.graded,
      gradedDescription: multiLangData.gradedDescription,
    },
  };

  // Only include policyId if it exists in the source data
  if (multiLangData.policyId) {
    result.policyId = multiLangData.policyId;
  }

  if (multiLangData.isEnable) {
    result.isEnable = multiLangData.isEnable;
  }

  return result;
};

// Helper function to convert legacy data to multilingual format
export const convertFromBackendFormat = (legacyData) => {
  // If already converted, return as-is
  if (
    legacyData.graded &&
    typeof legacyData.graded === 'object' &&
    legacyData.graded.en !== undefined
  ) {
    return legacyData;
  }

  if (legacyData.translations) {
    return {
      id: legacyData.id, // Preserve the ID for editing
      graded: legacyData.translations.graded || { en: legacyData.graded },
      gradedDescription: legacyData.translations.gradedDescription || {
        en: legacyData.gradedDescription,
      },
      policyId: legacyData.policyId,
      isEnable: legacyData.isEnable || false,
    };
  }

  // Legacy format without translations
  return {
    id: legacyData.id, // Preserve the ID for editing
    graded: { en: legacyData.graded || '' },
    gradedDescription: { en: legacyData.gradedDescription || '' },
    policyId: legacyData.policyId,
    isEnable: legacyData.isEnable || false,
  };
};

export const initialValues = (form, isEdit = false) => {
  if (!form) {
    const values = {
      graded: { en: '' },
      gradedDescription: { en: '' },
    };

    // Only include policyId for create operations
    if (!isEdit) {
      values.policyId = '';
    }

    if (isEdit) {
      values.isEnable = false;
    }

    return values;
  }

  const convertedForm = convertFromBackendFormat(form);

  // Remove policyId for edit operations
  if (isEdit) {
    const { policyId, ...formWithoutPolicyId } = convertedForm;
    return formWithoutPolicyId;
  }

  return convertedForm;
};

// Multilingual validation schema
const multiLangStringSchema = (t) =>
  Yup.object().shape({
    en: Yup.string().required(
      t('formulary.validation.english_translation_required')
    ),
    nl: Yup.string().optional(),
    vi: Yup.string().optional(),
  });

export const outcomeValidation = (t, isEdit = false) =>
  Yup.object().shape({
    graded: multiLangStringSchema(t),
    gradedDescription: multiLangStringSchema(t),
    policyId: isEdit
      ? Yup.string().optional()
      : Yup.string().required(t('formulary.validation.domain_required')),
    isEnable: Yup.boolean().optional(),
  });
